import React, { useState } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'
import Icon from '../../Atoms/Icon'
import Touchable from '../../Atoms/Touchable'
import Alert from '../../Atoms/Alert'
import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

const HelpIcon = styled(View)`
  height: 30px;
  align-items: center;
  justify-content: center;
  margin: 10px;
`

function Help ({ colour, title, description, size }) {
  const [showAlert, setShowAlert] = useState(false)

  return (
    <>
      <Alert visible={showAlert} onConfirm={() => setShowAlert(false)}>
        <Text bold>{title}</Text>
        <Text overrides={{ marginTop: theme.gutterUnit }}>{description}</Text>
      </Alert>
      <HelpIcon>
        <Touchable onPress={() => setShowAlert(true)}>
          <Icon name='help' size={size || 'xxl'} colour={colour} />
        </Touchable>
      </HelpIcon>
    </>
  )
}

export default Help
